import { isSatisfactionOwnMode } from '@/utils/satisfactionOwnMode'

/**
 * Level 1 só com own: qualquer rota de relatórios fora da pesquisa → pesquisa.
 * Precisa rodar em cada filho: o beforeEnter do parent /relatorios não reexecuta.
 */
export default (to, from, next) => {
  if (!isSatisfactionOwnMode()) {
    next()
    return
  }

  const name = String(to.name || '')
  if (!name.startsWith('reports.') || name.startsWith('reports.satisfactionSurvey')) {
    next()
    return
  }

  next({ name: 'reports.satisfactionSurvey.home' })
}
